<template>
  <eden-confirm-dialog
    title="Delete Activity"
    :button-text="'Delete'"
    :button-type="'danger'"
    :button-status="deleting"
    :show.sync="setShow"
    @confirm="deleteReward"
  >
    <p>
      This action cannot be undone. Are you sure you want to delete this
      activity,
      <span class="text-bold text-grey-primary">{{ reward.activity }}</span
      >?
    </p>
  </eden-confirm-dialog>
</template>

<script>
import rewards from "@/requests/discounts/rewards";

export default {
  name: "RewardDelete",
  props: {
    show: {
      type: Boolean,
      default: true,
    },
    reward: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      deleting: false,
    };
  },
  computed: {
    setShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit("update:show", value);
      },
    },
  },
  methods: {
    deleteReward() {
      this.deleting = true;
      rewards
        .delete(this.reward.id)
        .then((response) => {
          if (response.data.status) {
            this.$message.success(response.data.message);
            this.$emit("success");
            this.deleting = false;
            this.close();
          } else {
            this.deleting = false;
            this.$message.error(response.data.message);
          }
        })
        .catch((error) => {
          this.deleting = false;
          const errorMessage = error.response.data;
          if (errorMessage.errors) {
            const errorKeys = Object.keys(errorMessage.errors);
            this.$message.error(errorMessage.errors[errorKeys[0]].join(""));
          } else {
            this.$message.error(errorMessage.message);
          }
        });
    },
    close() {
      this.setShow = false;
      this.deleting = false;
    },
  },
};
</script>
